import React, { useState } from "react";
import { HashRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import BookingPage from "./Components/BookingPage";
import BookingTable from "./BookingTable";

function AppContent() {
  const location = useLocation();

  // Load admin route immediately from localStorage (no useEffect delay)
  const storedRoute = localStorage.getItem("adminRoute");
  const [adminRoute, setAdminRoute] = useState(storedRoute);

  const handleDynamicRoutes = (data) => {
    setAdminRoute(data);
    localStorage.setItem("adminRoute", data);
  };

  // ✅ Handle direct refresh: if user visits /admin-xxxxxx and it matches stored route
  if (adminRoute && location.pathname === `/${adminRoute}`) {
    return (
      <Routes>
        <Route path={`/${adminRoute}`} element={<BookingTable />} />
        <Route path="*" element={<Navigate to={`/${adminRoute}`} replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<BookingPage handleDynamicRoutes={handleDynamicRoutes} />} />
      {adminRoute && (
        <Route path={`/${adminRoute}`} element={<BookingTable />} />
      )}
      {/* Redirect unknown routes */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
